import {
  $getSelection,
  $isRangeSelection,
  INDENT_CONTENT_COMMAND,
  LexicalEditor,
  OUTDENT_CONTENT_COMMAND,
} from "lexical";
import React, { useEffect, useState } from "react";
import { IndentIcon, OutdentIcon } from "../../../../assets/icons/SvgIcons";
import { toolTipConstants } from "../../LexicalEditor.types";

const MIN_INDENT = 0;

const Adjust = ({
  editor,
  isRTL,
}: {
  editor: LexicalEditor;
  isRTL: boolean;
}) => {

  const [indentLevel, setIndentLevel] = useState<number>(0);

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          const anchorNode = selection.anchor.getNode();
          // Get the top-level element of the anchor node to determine its indent level
          const indent = anchorNode && anchorNode?.getTopLevelElement() && typeof anchorNode.getTopLevelElement()?.__indent === "number" ? anchorNode?.getTopLevelElement()?.__indent : 0;
          setIndentLevel(indent ?? 0);
        }
      });
    });
  }, [editor]);

  const canOutdent = indentLevel > MIN_INDENT;

  return (
    <>
      <button
        type="button"
        onClick={() => {
          if (canOutdent) {
            editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, undefined);
          }
        }}
        className="lexical-toolbarItem"
        aria-label="Outdent"
        title={toolTipConstants.decreaseIndent}
        disabled={!canOutdent}
        style={{ opacity: canOutdent ? 1 : 0.5, cursor: canOutdent ? "pointer" : "not-allowed" }}
      >
        <OutdentIcon />
      </button>
      <button
        type="button"
        onClick={() => {
          editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined);
        }}
        className="lexical-toolbarItem"
        aria-label="Indent"
        title={toolTipConstants.increaseIndent}
      >
        <IndentIcon />
      </button>
    </>
  );
};

export default Adjust;
